<template>
	<div>
		<modal
			:show="showSessionExpiresWarningModal"
			dialog-size="md"
			name="SessionExpiresWarning"
		>
			<template slot="header">
				<h4 class="modal-title">
					Warning your session is about to end due to inactivity.
				</h4>
			</template>

			<template>
				<p>You have been idle for to long. You will be logged out in <span role='timer' aria-live='polite' aria-atomic='true' aria-label='Time remaining'><strong>{{remainingTimeInSession | minutes}} minutes</strong></span> if you do not take an action. Choose below to logout out or remain logged in. </p>
			</template>

			<template slot="footer">
					<button type="button" class="btn btn-danger" data-dismiss="modal" @click="logout()">Logout</button>
					<button type="button" class="btn btn-primary" data-dismiss="modal" @click="remainLoggedIn()">Remain Logged In</button>
			</template>
		</modal>
		<div class="welcome-login text-center">
		<p class="text-left" v-if="showSessionDurationCountdown == 'Y'"><b>Session Expires At</b> {{vuexSessionExpiresAt}} <br/> <b>Countdown:</b> {{remainingTimeInSession | minutes}}</p>

			<!-- display the district info -->
            <img v-if="logoSrc" :src="logoSrc" :alt="districtName + ' logo'"/>
            <h3 class="district-name">{{ districtName }}</h3>
			<hr/>
            <h3 class="mb-10">{{ title }}</h3>
						<h3 v-if="subtitle.length" class="district-name mb-15">{{subtitle}}</h3>
						<div class="user-profile-wrap panel" v-if="!!user.first_name">
							<div class="panel-body">
								<div class="col-md-2"><font-awesome-icon icon="user" size="3x"></font-awesome-icon></div>
								<div class="col-md-10">
									<p><i>{{user.first_name}} {{user.last_name}} ({{user.friendly_id}}) <br/> {{user.email}}</i></p>
								</div>
							</div>
						</div>
            <!-- display any messages ( allowing html formatting ) -->
            <div v-if="getActiveMessage"
            	id="formFeedback"
            	:class="getMessageClass"
                v-html="getActiveMessage.content">
            </div>

			<div class="" v-if="!!mainButtonLink">
                <a 
					:href="secureButtonLink"
              		type="submit"
                	class="btn btn-block btn-primary">
                    {{mainButtonText}}
                </a>
            </div>
        </div>
				<div  class="go-back" v-if="!!entrypoint && entrypoint.includes('index.cfm/security/logout')">
					<button @click="logout(entrypoint);"><i class="fas fa-chevron-left"></i> {{backText}}</button>
				</div>
        <div class="go-back" v-else-if="!!entrypoint">
            <a :href="entrypoint"><i class="fas fa-chevron-left"></i> {{backText}}</a>
        </div>
    </div>
    
</template>

<script>
		import moment from 'moment';

		import { mapGetters, mapMutations } from 'vuex';
		import Modal from 'COMMONS/shared/Modal/Modal.vue';

		export default{
		props:{
			clientName: {
				type: String,
				required: false,
				default: "Third Party Site",
			},
			csrfToken: "",
			districtName : "",
			backText: {
				default: "Go Back"
			},
			logoSrc : "",
			loginText : {
					type: String
			},
				message : {
				type: Object,
				default: function(){
					return {
						category: "info",
						content: "Please enter the following:"
					}
				}
			},
			title: {
					type: String,
					default : "Notification"
			},
			subtitle: {
					type: String,
					default : ""
			},
			user: {
				type: Object,
				default: function(){
					return {}
				}
			},
			entrypoint : {
				type: String,
				required: true
			},
			postEndpoint : {
				type: String,
				required: true
			},
			mainButtonLink : {
				type: String,
			},
			mainButtonText : {
				type: String,
			},
			showPin : {
					type : Boolean,
					default : false
			},
			showEmail : {
					type : Boolean,
					default : true
			},
			showUsername : {
					type : Boolean,
					default : false
			},
			trustedClientFlg: {
				type: String,
				required: false,
				default:"N"
			},
			showSessionDurationCountdown: {
				type: String,
				required: false,
				default: "N"
			},
			sessionExpiresAt: {
				type: String,
				required: false,
				default: ""
			}
		},
		data(){
				return{
					username: "",
					password: "",
					email: "",
					pin: "",
					remainingTimeInSession: 0,
				}
		},
		components: {
			Modal,
		},
		computed: {
			...mapGetters({
				vuexSessionExpiresAt: 'sessionExpiresAt',
				showSessionExpiresWarningModal: "showSessionExpiresWarningModal",
			}),
			isTrustedClient(){
				return this.trustedClientFlg == 'Y';
			},
			secureButtonLink(){
				let secureLink = this.mainButtonLink;
				if( !!this.csrfToken ){
					secureLink += '&_csrfToken=' + this.csrfToken;
				} 
				return secureLink;
			},
			isFormInvalid() {
					return Object.keys( this.fields ).some( key => this.fields[ key ].invalid );
			},
			isFormTouched() {
				return Object.keys( this.fields ).some( key => this.fields[ key ].touched );
			},
			getMessageClass() {
				return "text-left alert alert-" + this.getActiveMessage.category;
			},
			getActiveMessage() {
				if( this.isFormInvalid && this.isFormTouched ){
					return {
						category : "warning",
						content : "Some required fields are missing!"
					}
				} else{
					return this.message;
				}
			}

		},
		methods: {
			...mapMutations(['setSessionExpiresAt','openSessionExpiresWarningModal', 'closeSessionExpiresWarningModal']),
			validateBeforeSubmit() {
				this.$validator.validateAll().then((result) => {
					if (result) {
							this.$refs.form.submit();
							return;
					}
				});
			},
			logout(logoutUrl){
				this.setSessionExpiresAt(0);
				clearInterval(this.countdownTimer);
				if( !!logoutUrl ) {
					window.location.replace(logoutUrl);
				} else if( !!this.entrypoint && this.entrypoint.includes('index.cfm/security/logout') ){
					window.location.replace(this.entrypoint);
				} else {
					window.location.replace('index.cfm/security/logout');
				}
			},
			remainLoggedIn(){
				location.reload();
			}
		},
		filters: {
			minutes: function (seconds) {
				let minute = String(Math.floor(seconds / 60));
				let second = String(seconds % 60).padStart(2, '0');
				return minute + ':' + second;
			}
		},
		watch: {
			vuexSessionExpiresAt:{
				handler(v){
					let self = this;
					const expiration = moment(v).unix();

					clearInterval(this.countdownTimer);
					
					this.countdownTimer = setInterval(function(){
						const warningTime = 60*3;
						let currentDateTime = moment().unix();
						self.remainingTimeInSession = Math.max(0, expiration - currentDateTime);
						
						if( self.remainingTimeInSession <= 0 ){
							self.logout();
						}
						
						if( !(self.remainingTimeInSession <= 0) && !this.showSessionExpiresWarningModal && self.remainingTimeInSession <= warningTime ){
							self.openSessionExpiresWarningModal();
						}

					}, 1000);
				},
				immediate: true
			},
			sessionExpiresAt:{
				handler(v){
					this.setSessionExpiresAt(v);
					this.closeSessionExpiresWarningModal();
				},
				immediate: true
			}
		}
	}
</script>